import {
  Dumbbell,
  Weight,
  Trophy,
  Flame,
  HeartPulse,
  PersonStanding,
  Shuffle,
  Activity,
} from 'lucide-react';
import type { Discipline } from '../types';

interface DisciplineMeta {
  value: Discipline;
  label: string;
  icon: React.ElementType;
}

export const disciplines: DisciplineMeta[] = [
  { value: 'bodybuilding', label: 'Musculación', icon: Dumbbell },
  { value: 'powerlifting', label: 'Fuerza / Powerlifting', icon: Weight },
  { value: 'weightlifting', label: 'Halterofilia', icon: Trophy },
  { value: 'crossfit', label: 'CrossFit / Funcional', icon: Flame },
  { value: 'cardio', label: 'Cardio / Resistencia', icon: HeartPulse },
  { value: 'calisthenics', label: 'Calistenia', icon: PersonStanding },
  { value: 'hybrid', label: 'Híbrido', icon: Shuffle },
  { value: 'general', label: 'Acondicionamiento general', icon: Activity },
];

const byValue: Record<string, DisciplineMeta> = Object.fromEntries(
  disciplines.map((d) => [d.value, d])
);

export function disciplineMeta(value?: string | null): DisciplineMeta | null {
  return value ? byValue[value] ?? null : null;
}

/** Badge monocromo con ícono dorado para mostrar la disciplina de un plan. */
export function DisciplineBadge({
  discipline,
  className = '',
}: {
  discipline?: string | null;
  className?: string;
}) {
  const meta = disciplineMeta(discipline);
  if (!meta) return null;
  const Icon = meta.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-dark-800 border border-dark-700 text-dark-200 ${className}`}
    >
      <Icon className="w-3.5 h-3.5 text-primary-400" />
      {meta.label}
    </span>
  );
}
